<script setup>
import {computed, defineEmits, defineProps, onMounted, ref, watch} from "vue";
import {couponConf} from "@/utils/config";
import store from "@/store";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["hll-scal"];
    }
  }
});
const coupon = computed(() => {
  return props.couponLst?.[0]?.data || []
})
const order_from = computed(() => store.state.orderFrom)
const emit = defineEmits(['login'])
const showPayLoading = ref(false)
const product = ref(coupon.value?.[0] || {})
watch(() => props.account, to => {
  if (Object.keys(to).length && Object.keys(product.value).length) {
    showPayLoading.value = true
  }
})
const maxNumber = computed(() => {
  if (Object.keys(props.account).length < 1) return 1;
  return Math.floor(parseFloat(props.account.balance_miles) / parseFloat(coupon.value?.[0]?.score_data?.[props.type.login]?.total))
})
const num = ref(1)
const mobile = ref("")
const loading = ref(false)
const rechargeTab = ref("recharge")
const sendSms = ref(false)
const realname = ref(false)
onMounted(() => {
  store.commit("getOrderFrom")
})
const payment = () => {
  if (!/^1[3-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("手机号填写错误")
  }
  if (!sendSms.value) {
    sendSms.value = true
    return;
  }
  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: props.account.access_token,
    user_id: props.account.user_id
  } : {cust_id: props.account.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: product.value.id,
      uid: props.account.uid,
      pay_type: props.type.login,
      pay_params,
      number: num.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
    }
    if (props.type.login !== 'xm_air')
      router.push({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
</script>

<template>
  <div class="hll-product-lst">
    <div class="hll-coupon-header">
      <el-image src="https://images.jifen360.com/haolilai/header.png"/>
    </div>
    <div class="hll-coupon-its">
      <div class="hll-coupon-info" v-for="coup in coupon" :key="coup.id">
        <div class="hll-coupon-left">
          <div class="face-value">
            <div class="hll-coupon-price-unit">￥</div>
            <div class="hll-coupon-price-money">{{ coup?.face_value }}</div>
          </div>
          <el-image src="https://images.jifen360.com/haolilai/logo.png"/>
        </div>
        <div class="hll-coupon-right">
          <div class="hll-coupon-right-info">
            <div class="hll-coupon-right-info-title">{{ coup?.name }}</div>
            <div class="hll-pay-product-price">
              <el-text type="danger" class="pyf-face-money">{{ coup?.score_data?.[type?.login]?.total }}</el-text>
              <el-text type="info" class="pyf-face-unit">{{ coup?.score_data?.[type?.login]?.unit }}</el-text>
            </div>
          </div>
          <div class="hll-coupon-right-btn">
            <el-button round type="primary" @click="product = coup,emit('login')"
                       v-if="Object.keys(account).length < 1">立即兑换
            </el-button>
            <el-button round type="primary"
                       v-else-if="Object.keys(account).length > 0 && parseInt(account.balance_miles) >= parseInt(coup?.score_data?.[type?.login]?.total)"
                       @click="product = coup,showPayLoading = true">
              立即兑换
            </el-button>
            <el-button round type="primary" disabled v-else>可用{{
                coup?.score_data?.[type?.login]?.unit
              }}不足
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="hll-recharge-content">
    <div class="hll-recharge-tabs">
      <div class="hll-recharge-tabs-item hll-recharge-tabs-left" @click="rechargeTab  = 'recharge'"></div>
      <div class="hll-recharge-tabs-item hll-recharge-tabs-right" @click="rechargeTab  = 'step'"></div>
      <el-image src="https://images.jifen360.com/haolilai/recharge.png" v-if="rechargeTab==='recharge'"/>
      <el-image src="https://images.jifen360.com/haolilai/step.png" v-if="rechargeTab==='step'"
                @click="rechargeTab  = 'step'"/>
    </div>
    <div class="hll-recharge-content-info" v-if="rechargeTab === 'recharge'">
      <div v-for="(recharge,inx) in type.desc" :key="inx">
        <h4>{{ recharge.title }}</h4>
        <ol class="hll-recharge-content-lst">
          <li v-for="(cont,i) in recharge.content" :key="i" v-html="cont"></li>
        </ol>
      </div>
    </div>
    <div class="hll-recharge-step-image" v-if="rechargeTab==='step'">
      <div class="hll-recharge-step-image-info">
        <el-image src="https://images.jifen360.com/haolilai/step-img.png"/>
      </div>
    </div>
  </div>
  <el-drawer v-model="showPayLoading" direction="btt" class="pay-box" size="480" :show-close="false">
    <template #header>
      <div class="hll-pat-drawer-header">
        <div class="hll-pat-drawer-header-logo">
          <el-image src="https://images.jifen360.com/haolilai/logo.png"/>
        </div>
        <div class="hll-pat-drawer-header-product">
          <h4>{{ product?.name }}</h4>
          <div><el-text type="info">无门槛 可叠加使用</el-text></div>
          <div class="hll-pay-product-price">
            <el-text type="danger" class="pyf-face-money">{{ product?.score_data?.[type?.login]?.total }}</el-text>
            <el-text type="info" class="pyf-face-unit">{{ product?.score_data?.[type?.login]?.unit }}</el-text>
          </div>
        </div>
      </div>
    </template>
    <div class="hll-pay-content">
      <el-text type="info">
        兑换成功后，蛋糕卡卡号和密码将以短信的形式发放至下方
        <el-text type="danger">填写的手机号</el-text>
        ，因手机号填写错误造成的损失由会员本人承担。
      </el-text>
    </div>
    <el-card shadow="never">
      <div class="hll-form">
        <div class="hll-form-label">收货手机号</div>
        <div class="hll-form-input">
          <el-input v-model="mobile" placeholder="请输入手机号" clearable/>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div class="hll-form">
        <div class="hll-form-label">兑换数量</div>
        <div class="hll-form-input">
          <el-input-number v-model="num" :min="1" :max="maxNumber" clearable/>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div class="hll-form">
        <div class="hll-form-label">可用{{ product?.score_data?.[type?.login]?.unit }}</div>
        <div class="hll-form-input">
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="hll-form">
        <div class="hll-form-label">支付{{ product?.score_data?.[type?.login]?.unit }}</div>
        <div class="hll-form-input">
          {{ product?.score_data?.[type?.login]?.total * num }}
        </div>
      </div>
    </el-card>
    <div class="hll-pay-btn">
      <el-button type="danger" round @click="payment" size="large" :loading="loading">立即兑换</el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname"/>
</template>

<style scoped lang="less">
.hll-product-lst {
  box-sizing: border-box;
  background: #ffffff;
  margin: 10px 15px;
  border-radius: 18px;
  overflow: hidden;

  .hll-coupon-header {
    .el-image {
      width: 100%;
    }
  }

  .hll-coupon-its {
    box-sizing: border-box;
    padding: 0 10px;
    margin-top: -10px;

    .hll-coupon-info {
      background: url("https://images.jifen360.com/haolilai/product.png") no-repeat;
      background-size: 100% 100%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 10px;

      .hll-coupon-left {
        flex-basis: 25%;
        text-align: center;
        width: 25%;
        box-sizing: border-box;

        .face-value {
          display: flex;
          justify-content: center;
          margin-bottom: 10px;
          font-size: 1.72rem;
          color: var(--theme-text-color);
          font-weight: 600;

          .hll-coupon-price-unit {
            font-size: .95rem;
          }
        }

        .el-image {
          width: 80%;
        }
      }

      .hll-coupon-right {
        flex-basis: 75%;
        box-sizing: border-box;
        width: 75%;
        //background: #FAFAFA;
        padding-left: 10px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        font-size: .95rem;
        line-height: 1.7;

        .hll-coupon-right-info-title {
          //禁止换行
          white-space: nowrap;
          font-size: .8rem;
        }

        .pyf-face-money {
          font-size: 1.45rem;
        }

        .el-button {
          background: #ffffff;
          color: var(--btn-color);
          width: 100px;
          border-color: #ffffff;
        }
      }
    }
  }
}

.hll-recharge-content {
  margin: 10px 15px;

  .hll-recharge-tabs {
    position: relative;

    .hll-recharge-tabs-item {
      position: absolute;
      top: 0;
      //background: #ffffff;
      bottom: 0;
      width: 50%;
      z-index: 999;

      &.hll-recharge-tabs-left {
        left: 0;
      }

      &.hll-recharge-tabs-right {
        right: 0;
      }
    }
  }

  .hll-recharge-content-info {
    box-sizing: border-box;
    padding: 10px;
    background: #ffffff;
    border-radius: 0 0 12px 12px;
    margin-top: -10px;

    .hll-recharge-content-lst {
      padding-left: 15px;
      line-height: 1.5;
      padding-top: 5px;
      text-align: justify-all;
      font-size: .8rem;
    }
  }

  .hll-recharge-step-image {
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 0 0 12px 12px;
    margin-top: -5px;
    padding: 10px;

    .hll-recharge-step-image-info {
      box-sizing: border-box;
      padding: 10px;
      border: 1px solid #F2F2F2;
      border-radius: 12px;

      .el-image {
        background: #F2F2F2;
        padding: 10px;
        border-radius: 12px;
      }
    }
  }
}

.pay-box {
  .hll-pat-drawer-header {
    display: flex;
    align-items: center;

    .hll-pat-drawer-header-logo {
      flex-basis: 120px;
      width: 120px;
      background: #E5E5E5;
      border-radius: 12px;
      margin-right: 10px;
      text-align: center;
      box-sizing: border-box;
      padding: 20px;
    }

    .hll-pat-drawer-header-product {
      flex-basis: calc(100% - 130px);
      width: calc(100% - 130px);
      line-height: 1.45;

      .hll-pay-product-price {
        //display: flex;
        .pyf-face-money {
          font-size: 1.45rem;
        }
      }
    }
  }

  .hll-pay-content {
    margin-bottom: 10px;
  }

  .el-card {
    margin-bottom: 10px;
    --el-card-border-radius: 10px;
    --el-card-border: none;

    .hll-form {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & + .hll-form {
        padding-top: 10px;
        margin-top: 10px;
        border-top: var(--el-border);
      }

      .hll-form-label {
        flex-basis: 100px;
        width: 100px;
      }

      .hll-form-input {
        width: calc(100% - 120px);
        flex-basis: calc(100% - 120px);
        text-align: right;
      }
    }
  }

  .hll-pay-btn {
    margin-top: 15px;

    .el-button {
      width: 100%;
    }
  }
}

</style>